import { BackgroundControlFileWithFile } from '@ansvar-sakerhet/api-client';

export const getReportFileName = (
  report: BackgroundControlFileWithFile | undefined
): string | undefined => {
  return report?.fileName || report?.file?.originalName || undefined;
};
